import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import gewerbeHeroBgAsset from "@/assets/gewerbe-hero-bg.png";
import gewerbeG2ContractingAsset from "@/assets/gewerbe-g2-contracting.png";
import gewerbeReferenzIndustriedachAsset from "@/assets/gewerbe-referenz-industriedach.png";
import gewerbeGrosseDaecherAsset from "@/assets/gewerbe-grosse-daecher.png";
import gewerbeBetriebskostenSenkenAsset from "@/assets/gewerbe-betriebskosten-senken.png";
import gewerbeVersorgungAbsichernAsset from "@/assets/gewerbe-versorgung-absichern.png";
import Seo, { serviceSchema } from "@/components/feature/Seo";
export default function Gewerbe() {
  return (
    <>
      <Seo
        title="Für Ihren Betrieb | Zweering Elektrotechnik Emmerich am Rhein"
        description="Energielösungen für Gewerbe und Industrie: Photovoltaik, Lastmanagement, Ladeinfrastruktur und Versorgungssicherheit in Emmerich am Rhein und Umgebung."
        canonical="https://zweering.de/gewerbe"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Für wen", "url": "https://zweering.de/gewerbe"}, {"name": "Gewerbe", "url": "https://zweering.de/gewerbe"}]}
      />
      <LeistungsseiteTemplate
      label="FÜR WEN"
      title="FÜR IHREN BETRIEB"
      subline="Energiekosten senken, unabhängiger produzieren, Versorgung sichern — Energielösungen für Gewerbe und Industrie in Emmerich am Rhein und Umgebung."
      heroImage={gewerbeHeroBgAsset}
      heroImageAlt="Großes Gewerbegebäude mit ausgedehnter Photovoltaik-Anlage auf dem Dach"
      leadText={
        <>
          Strom ist für Betriebe ein realer Kostenfaktor. Wer ihn selbst erzeugt und
          clever nutzt, wird{" "}
          <span style={{ color: "#4CAF50" }}>unabhängiger und planbarer</span> —
          besonders, wenn der Verbrauch tagsüber am höchsten ist.
        </>
      }
      panels={[
        {
          title: "GROSSE DÄCHER, GROSSE CHANCEN",
          body: "Gewerbedächer bieten Platz für leistungsstarke Photovoltaik — Strom genau dann, wenn Ihr Betrieb ihn braucht.",
          ctaLabel: "Zur Photovoltaik →",
          ctaHref: "/photovoltaik",
          image: gewerbeGrosseDaecherAsset,
          imageAlt: "Großes Gewerbedach mit ausgedehnter Photovoltaik-Anlage",
        },
        {
          title: (
            <>
              <span className="whitespace-nowrap" style={{ color: "#4CAF50" }}>BETRIEBSKOSTEN</span>
              <br />
              <span className="whitespace-nowrap">SENKEN</span>
            </>
          ),
          titleSize: "clamp(1.125rem, 2.6vw, 1.75rem)",
          body: "Eigener Solarstrom reduziert Ihre Stromkosten spürbar und macht Sie unabhängiger von Preisschwankungen.",
          image: gewerbeBetriebskostenSenkenAsset,
          imageAlt: "Gewerbegebäude mit Photovoltaik-Anlage auf dem Dach",
        },
        {
          title: "VERSORGUNG ABSICHERN",
          body: "Mit Speicher- und Notstromlösungen bleibt Ihr Betrieb auch bei Netzproblemen handlungsfähig.",
          ctaLabel: "Zur Notstrom-Lösung →",
          ctaHref: "/notstrom",
          image: gewerbeVersorgungAbsichernAsset,
          imageAlt: "Gewerbedach mit Photovoltaik-Anlage und Klimaanlagen unter bewölktem Himmel",
        },
        {
          title: "GEPRÜFT & SICHER",
          body: "E-Check und Wartung Ihrer Elektroinstallation — normgerecht dokumentiert, vom Meisterbetrieb.",
          ctaLabel: "Zum E-Check →",
          ctaHref: "/e-check",
          image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2025/05/IMG_0177-scaled.jpeg",
          imageAlt: "E-Check Dokumentation im Gewerbebetrieb in Emmerich am Rhein",
        },
      ]}
      testimonials={allTestimonials}
      manifest={<><span className="block">EIGENER STROM.</span><span className="block">WENIGER KOSTEN.</span><span className="block">MEHR UNABHÄNGIGKEIT.</span></>}
      caseStudy={{
        title: "PHOTOVOLTAIK AUF INDUSTRIEDACH",
        text: "Großflächige PV-Anlage für einen Gewerbebetrieb — geplant und installiert aus einer Hand in Emmerich am Rhein und Umgebung.",
        href: "/referenzen",
        linkLabel: "Mehr Referenzen",
        image: gewerbeReferenzIndustriedachAsset,
        imageAlt: "Luftaufnahme eines großen Gewerbegebäudes mit ausgedehnter Photovoltaik-Anlage auf dem Dach",
      }}
      faq={[
        {
          frage: "Lohnt sich Photovoltaik für meinen Betrieb?",
          antwort:
            "Besonders, wenn Ihr Stromverbrauch tagsüber hoch ist — dann nutzen Sie den Solarstrom direkt. Wir prüfen die Wirtschaftlichkeit für Ihr Objekt.",
        },
        {
          frage: "Können Sie auch große Dächer umsetzen?",
          antwort:
            "Ja. Wir planen und installieren PV-Anlagen für Gewerbe- und Industriedächer jeder Größe.",
        },
        {
          frage: "Was ist mit Versorgungssicherheit?",
          antwort:
            "Mit Speicher- und Notstromlösungen sichern wir kritische Bereiche Ihres Betriebs ab. Welche Lösung passt, klären wir gemeinsam.",
        },
        {
          frage: "Übernehmen Sie auch die regelmäßige Prüfung?",
          antwort:
            "Ja. E-Check und Wartung Ihrer Elektroinstallation gehören zu unserem Service — aus einer Hand.",
        },
      ]}
      ctaText={{
        headline: "BETRIEBSKOSTEN SENKEN, UNABHÄNGIGER WERDEN?",
        subtext: "Kostenlose Beratung für Gewerbe und Industrie.",
        buttonLabel: "Beratung anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "G2 CONTRACTING",
        text: "Energiemanagement und dynamische Tarife — für Betriebe besonders lohnend.",
        href: "/g2-contracting",
        image: gewerbeG2ContractingAsset,
        imageAlt: "Landwirtschaftliches Gebäude mit großer Photovoltaik-Anlage auf dem Dach",
      }}
    />
    </>
  );
}
